import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useAuth0 } from './auth0-wrapper';

const HttpSetup = ({ children }) => {
  const { getTokenSilently } = useAuth0();
  const [setupDone, setSetupDone] = useState(false);

  useEffect(() => {
    const setupHttp = async () => {
      const token = await getTokenSilently();
      axios.defaults.headers.common = {
        Authorization: `Bearer ${token}`,
      };

      setSetupDone(true);
    };

    setupHttp();
  }, [getTokenSilently]);

  if (!setupDone) {
    return <div>Loading...</div>;
  }

  return children;
};

HttpSetup.propTypes = {
  children: PropTypes.any,
};

export default HttpSetup;
